import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-[#0F1224] flex flex-col" data-testid="privacy-page">
      {/* Header */}
      <header className="p-4 sm:p-6 flex items-center justify-between">
        <Link to="/" className="inline-flex items-center gap-2">
          <img src="/logo-64.png" alt="Payday Control" className="w-10 h-10 rounded-xl" />
          <span className="font-heading font-bold text-lg text-white">Payday Control</span>
        </Link>
        <Link 
          to="/" 
          className="inline-flex items-center gap-1 text-[#9CA3AF] hover:text-white transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          <span className="text-sm">Back</span>
        </Link>
      </header>

      {/* Main Content */}
      <main className="flex-1 px-4 py-8 max-w-3xl mx-auto w-full">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="space-y-8"
        >
          <div>
            <h1 className="font-heading text-2xl sm:text-3xl font-bold text-white mb-2">
              Privacy Policy
            </h1>
            <p className="text-[#6B7280] text-sm">Payday Control</p>
          </div>

          <div className="prose prose-invert max-w-none space-y-6">
            <p className="text-[#9CA3AF]">
              <strong className="text-white">Effective Date:</strong> December 2025
            </p>

            <p className="text-[#9CA3AF]">
              Payday Control respects your privacy and is committed to protecting your personal information.
            </p>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-white">Information We Collect</h2>
              <p className="text-[#9CA3AF]">
                When you create an account or use Payday Control, we may collect the following information:
              </p>
              <ul className="list-disc list-inside text-[#9CA3AF] space-y-2 ml-2">
                <li>Email address</li>
                <li>Account login credentials</li>
                <li>Financial information entered by you, such as balance, bills, and spending entries</li>
                <li>Notification preferences</li>
                <li>Basic usage data to improve the service</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-white">Financial Data Privacy</h2>
              <p className="text-[#9CA3AF]">
                All financial information entered into Payday Control is private to the user.
              </p>
              <p className="text-[#9CA3AF]">
                The Payday Control administrator does <strong className="text-white">NOT</strong> have access to view individual user financial information such as balances, bills, or spending data.
              </p>
              <p className="text-[#9CA3AF]">
                Financial data is stored only so the application can calculate your Safe to Spend amount and display it within your account.
              </p>
              <p className="text-[#9CA3AF]">
                We do not sell, rent, or share personal financial data with third parties.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-white">How We Use Your Information</h2>
              <p className="text-[#9CA3AF]">
                Your information is used only to:
              </p>
              <ul className="list-disc list-inside text-[#9CA3AF] space-y-2 ml-2">
                <li>Provide the Payday Control service</li>
                <li>Calculate Safe to Spend amounts</li>
                <li>Send notifications you choose to enable</li>
                <li>Improve the functionality of the application</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-white">Account Deletion</h2>
              <p className="text-[#9CA3AF]">
                Users can delete their account at any time from the Settings page.
              </p>
              <p className="text-[#9CA3AF]">
                When an account is deleted, associated financial data is permanently removed from the system.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-white">Contact</h2>
              <p className="text-[#9CA3AF]">
                If you have any questions regarding this Privacy Policy, please contact:
              </p>
              <p>
                <a 
                  href="mailto:support@paydaycontrol.app" 
                  className="text-[#63E6E2] hover:underline"
                >
                  support@paydaycontrol.app
                </a>
              </p>
            </section>
          </div>
        </motion.div>
      </main>

      {/* Footer */}
      <footer className="p-4 sm:p-6 border-t border-[#2D3354]">
        <div className="flex items-center justify-center gap-4 text-sm text-[#6B7280]">
          <Link to="/privacy" className="text-[#63E6E2]">Privacy Policy</Link>
          <span>|</span>
          <Link to="/terms" className="hover:text-white transition-colors">Terms of Service</Link>
          <span>|</span>
          <a href="mailto:support@paydaycontrol.app" className="hover:text-white transition-colors">Contact</a>
        </div>
      </footer>
    </div>
  );
}
